import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string({ message: 'Email is required' }).email({ message: 'Please enter a valid email address' })
});

export const verifyCodeSchema = z.object({
  code: z
    .string()
    .length(6, { message: 'Code must be exactly 6 digits' })
    .regex(/^\d+$/, { message: 'Code must contain only digits' })
});
